<template>
  <div ref="mapRef" class="mapBox"></div>
  <div class="mapBox mainBox">
    <nyTit pathUrl="/mapAnalysis" />

    <div class="geo-marker-legend">
      <div v-for="item in geoMarkerLegendItems" :key="item.label">
        <i :style="{ background: item.color }"></i>
        <span>{{ item.label }}</span>
      </div>
    </div>

    <div class="map-zoom-tools">
      <button type="button" title="放大地图" @click.stop="zoomMap(1)">＋</button>
      <button type="button" title="还原视角" @click.stop="resetMapView">复位</button>
      <button type="button" title="缩小地图" @click.stop="zoomMap(-1)">－</button>
    </div>

    <div class="content">
      <section class="left-panel">
        <div class="top-row">
          <div class="top-row-left glass-card land-card">
            <div class="section-title">上蔡县耕地总面积统计</div>
            <div class="land-content">
              <div class="land-left">
                <div class="land-main">
                  <div>
                    <div class="land-number">162.8<span>万亩</span></div>
                    <div class="land-label">耕地总面积</div>
                  </div>
                  <div class="increase-grid">
                    <div>
                      <b>较上年增加</b>
                      <strong>1.26万亩</strong>
                    </div>
                    <div>
                      <b>同比增长</b>
                      <strong>0.78%</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="land-right">
                <div ref="landBarRef" class="chart full-chart"></div>
                <div class="chart-caption">数据口径：县域耕地保护年度核查综合测算</div>
              </div>
            </div>
          </div>
          

          <div class="glass-card water-card">
            <div class="section-title">上蔡县沟道水系总长统计</div>
            <div class="water-kpis">
              <div>
                <span>骨干河沟长度</span>
                <b>220</b><em>km</em>
                <p>9条大中型沟道</p>
              </div>
              <div>
                <span>防洪排涝总长</span>
                <b>440</b><em>km</em>
                <p>河道与排涝沟全线</p>
              </div>
              <div>
                <span>全域沟渠水系</span>
                <b>4578</b><em>km</em>
                <p>沟干支斗农毛五级水系</p>
              </div>
            </div>
            <div class="water-bottom">
              <div class="water-table">
                <p><span>小洪河</span><b>52.76km</b></p>
                <p><span>黑河</span><b>62.30km</b></p>
                <p><span>汝河及支流</span><b>58.20km</b></p>
                <p><span>小洪河支沟</span><b>86.50km</b></p>
                <p><span>堰渠</span><b>42.40km</b></p>
                <p><span>镇村排水沟</span><b>137.84km</b></p>
              </div>
              <div class="water-summary">
                <p><span>田间沟渠</span><b>2218km</b></p>
                <p><span>已完成连通清淤渠道</span><b>715km</b></p>
              </div>
            </div>
          </div>
        </div>

        <div class="build-section">
          <h2>上蔡县村镇建筑占地统计</h2>
          <p class="subtitle">全域城乡村镇建设用地业务台账汇总 | 单位：公顷</p>

          <div class="glass-card build-overview">
            <div class="progress-area">
              <div class="overview-title">全县城乡建设用地总规模</div>
              <div class="scale-line">
                <span style="width: 88%"></span>
              </div>
              <div class="build-values">
                <b>21179.97<span>公顷</span></b>
                <b>14.0<span>%</span></b>
              </div>
            </div>
            <div class="total-list">
              <span>分项面积</span>
              <p>18717.81</p>
              <p>2123.85</p>
              <p>338.31</p>
            </div>
            <div ref="buildPieRef" class="chart pie-chart"></div>
            <div class="pie-note">
              <p>农村居民点 <b>18717.81 公顷</b></p>
              <p>集镇住宅 <b>2123.85 公顷</b></p>
              <p>工矿配套 <b>338.31 公顷</b></p>
            </div>
          </div>

          <div class="build-cards">
            <div class="glass-card small-card" v-for="item in buildCards" :key="item.title">
              <h3>{{ item.title }}</h3>
              <b>{{ item.value }}<span>公顷</span></b>
              <p>{{ item.desc }}</p>
            </div>
          </div>

          <div class="source-line">
            数据口径：上蔡县土地利用现状基数台账综合测算 | 县域总面积151422.68公顷 | 建筑占地包含房屋基底、院落、村内硬化配套建设占地。
          </div>
        </div>
      </section>

      <section class="right-panel">
        <div class="right-layout">
          <div class="zone-column">
            <div class="panel-title">片区汇总统计</div>
            <div class="zone-grid">
              <div class="zone-item" v-for="item in zoneStats" :key="item.label">
                <span>{{ item.label }}</span>
                <b :class="{ warm: item.warm }">{{ item.value }}</b>
              </div>
            </div>
            <div class="panel-title title-gap">片区7日气象均值趋势</div>
            <div ref="weatherLineRef" class="chart weather-chart"></div>
          </div>

          <div class="monitor-column">
            <div class="main-heading">
              <h2>上蔡县卫星轮询+地面站点实测</h2>
              <p>耕地与河道监测双来源数据融合机制</p>
            </div>

            <div class="monitor-top">
              <div class="glass-card satellite-card">
                <div class="card-title">卫星轮询链路</div>
                <div class="sat-body">
                  <div class="sat-map">
                    <img src="../assets/img/map1.png" alt="卫星地图">
                  </div>
                  <div class="sat-info">
                    <p><b>晴天影像重访周期</b><span>5天</span><em>09:18 / 14:32 / 17:05</em></p>
                    <p><b>今日轮询时段</b><span>3批次</span><em>09:16 / 14:32 / 17:05</em></p>
                    <p><b>云量识别</b><span>8.6%</span><em>地块解译完成率 96.4%</em></p>
                  </div>
                </div>
              </div>

              <div class="glass-card station-card">
                <div class="card-title">地面站点实测</div>
                <div class="station-list">
                  <div class="station-item" v-for="item in stationStats" :key="item.title">
                    <i>{{ item.icon }}</i>
                    <div>
                      <h3>{{ item.title }}</h3>
                      <p>{{ item.desc }}</p>
                    </div>
                    <b>{{ item.value }}</b>
                  </div>
                </div>
              </div>
            </div>

            <div class="business-section">
              <div class="main-heading small-heading">
                <h2>点位业务数据联动机制</h2>
              </div>
              <div class="business-grid">
                <div class="glass-card business-card field-card">
                  <div class="card-title">农田点位联动监测</div>
                  <div class="business-row" v-for="(item, index) in fieldLinks" :key="item.title">
                    <i>{{ item.icon }}</i>
                    <div>
                      <h3>{{ item.title }}</h3>
                      <p>{{ item.desc }}</p>
                    </div>
                    <div :ref="(el) => setSparkRef(el, index)" class="spark-chart"></div>
                  </div>
                </div>
                <div class="glass-card business-card field-card">
                  <div class="card-title">河道点位联动监测</div>
                  <div class="business-row" v-for="(item, index) in riverLinks" :key="item.title">
                    <i>{{ item.icon }}</i>
                    <div>
                      <h3>{{ item.title }}</h3>
                      <p>{{ item.desc }}</p>
                    </div>
                    <div :ref="(el) => setSparkRef(el, index + fieldLinks.length)" class="spark-chart"></div>
                  </div>
                </div>
              </div>
              <!-- <div class="source-note">数据同步至卫星轮询+地面站点实测联动更新</div> -->
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from "vue";
import nyTit from "@/components/nyTit";
import * as echarts from "echarts";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import Gep from "../utils/范围面.json";

const mapRef = ref(null);
const map = ref(null);
const mapObj = ref(null);
const boundaryData = Gep;
const defaultMapView = {
  center: [33.248258780732435, 114.18800353654662],
  zoom: 15,
};
const landBarRef = ref(null);
const buildPieRef = ref(null);
const weatherLineRef = ref(null);
const sparkRefs = ref([]);
const chartInstances = [];

const geoMarkerLegendItems = [
  { label: "村镇建筑", color: "rgba(255, 207, 93, 0.9)" },
  { label: "农田地块", color: "rgba(64, 255, 181, 0.9)" },
  { label: "河流水系", color: "rgba(75, 182, 255, 0.9)" },
  { label: "监测站点", color: "rgba(199, 123, 255, 0.9)" },
];

const geoMarkerPoints = [
  { name: "村镇建筑识别点", type: "building", coord: [33.2479, 114.1904], value: "建筑占地核查" },
  { name: "集镇建设观测点", type: "building", coord: [33.2498, 114.2008], value: "建设边界比对" },
  { name: "高标准农田标记点", type: "field", coord: [33.2547, 114.1768], value: "农田地块识别" },
  { name: "耕地保护标记点", type: "field", coord: [33.2418, 114.1843], value: "耕地边界核验" },
  { name: "小洪河水系点", type: "river", coord: [33.2578, 114.1912], value: "河道巡查定位" },
  { name: "黑河支流水系点", type: "river", coord: [33.2527, 114.1974], value: "水系连通识别" },
  { name: "土壤墒情站", type: "station", coord: [33.2454, 114.1809], value: "含水率28.6%" },
  { name: "气象观测站", type: "station", coord: [33.2509, 114.1875], value: "在线率98.7%" },
];

const geoMarkerAreas = [
  {
    name: "农田地块标记面",
    type: "field",
    color: "#40ffb5",
    coordinates: [
      [33.2572, 114.1711],
      [33.2564, 114.1836],
      [33.2498, 114.1888],
      [33.2437, 114.1835],
      [33.2463, 114.1718],
    ],
  },
  {
    name: "村镇建筑识别面",
    type: "building",
    color: "#ffcf5d",
    coordinates: [
      [33.2516, 114.1934],
      [33.2497, 114.2058],
      [33.2424, 114.2069],
      [33.2403, 114.1958],
      [33.2461, 114.1895],
    ],
  },
];

const geoRiverLines = [
  {
    name: "小洪河巡查线",
    color: "#4bb6ff",
    coordinates: [
      [33.2622, 114.1795],
      [33.2592, 114.1844],
      [33.2554, 114.1893],
      [33.2516, 114.1956],
    ],
  },
  {
    name: "黑河支流标记线",
    color: "#68e7ff",
    coordinates: [
      [33.2483, 114.1692],
      [33.2502, 114.1784],
      [33.2511, 114.1876],
      [33.2527, 114.1974],
    ],
  },
];

const markerTypeMeta = {
  building: { label: "建", color: "#ffcf5d" },
  field: { label: "田", color: "#40ffb5" },
  river: { label: "水", color: "#4bb6ff" },
  station: { label: "站", color: "#c77bff" },
};

const buildCards = [
  { title: "农村村镇核心建筑占地", value: "18717.81", desc: "县域行政村、自然村宅基地、院落、公共建筑" },
  { title: "乡镇集镇建成区占地", value: "2123.85", desc: "集镇住宅、商铺、公共配套不含中心城区街道范围" },
  { title: "村镇工矿配套建筑占地", value: "338.31", desc: "小型加工、农产品仓储、生产配套设施" },
];

const zoneStats = [
  { label: "当前片区耕地", value: "3260.5亩" },
  { label: "标记地块数量", value: "1286块" },
  { label: "7日平均气温", value: "25.1°C" },
  { label: "7日累计降水", value: "38.6mm" },
  { label: "平均风速", value: "3.4m/s" },
  { label: "最高温", value: "31.6°C", warm: true },
  { label: "最大降雨量", value: "28.4mm" },
  { label: "最大风速", value: "8.7m/s" },
];

const stationStats = [
  { icon: "土", title: "土壤墒情站", desc: "监测点126个 | 耕层含水率28.6%", value: "在线率97.6%" },
  { icon: "水", title: "河道水位站", desc: "监测断面42个 | 当前水位3.62m", value: "低于警戒0.98m" },
  { icon: "气", title: "气象观测站", desc: "气象观测站18个 | 数据5分钟更新", value: "在线率98.7%" },
];

const fieldLinks = [
  { icon: "土", title: "作物长势：叶面积指数", desc: "4.8，长势平稳，绿度、冠层覆盖趋稳" },
  { icon: "温", title: "土壤墒情：耕层含水率", desc: "28.6%，pH 7.2，土壤水分适宜" },
  { icon: "气", title: "降雨气象：日均气温", desc: "24.3°C，降水量12.8mm，日照时长6.4h" },
];

const riverLinks = [
  { icon: "pH", title: "水体水质：断面水质", desc: "pH 7.1，悬浮物18mg/L，水质等级良好" },
  { icon: "位", title: "河流水位：实时水位", desc: "3.62m，历史同站-0.18m，水位稳定" },
  { icon: "闸", title: "河道联动巡查：巡查事件", desc: "今日巡查12次，疑似堵点0个" },
];

function getRecentDateLabels(dayCount = 7) {
  const labels = [];
  const today = new Date();
  for (let i = dayCount - 1; i >= 0; i -= 1) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    labels.push(`${month}-${day}`);
  }
  return labels;
}

const mapType1 = ref(
  L.tileLayer(
    "https://map1.aikenong.com.cn/maps/vt/lyrs=y&hl=zh-CN&gl=cn&scale=2&src=app&x={x}&y={y}&z={z}",
    {
      subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
      opacity: 0.9,
      pane: "geoRasterPane",
      className: "geo-marker-satellite-tile",
    }
  )
);

const mapLabelType1 = ref(
  L.tileLayer(
    "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    {
      subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
      opacity: 0.84,
      pane: "geoLabelPane",
    }
  )
);

function setSparkRef(el, index) {
  if (el) {
    sparkRefs.value[index] = el;
  }
}

const initMap = () => {
  map.value.createPane("geoRasterPane");
  map.value.getPane("geoRasterPane").style.zIndex = 350;
  map.value.createPane("geoThematicPane");
  map.value.getPane("geoThematicPane").style.zIndex = 370;
  map.value.createPane("geoMarkerPane");
  map.value.getPane("geoMarkerPane").style.zIndex = 390;
  map.value.createPane("geoLabelPane");
  map.value.getPane("geoLabelPane").style.zIndex = 400;
  map.value.addLayer(mapType1.value);
  map.value.addLayer(mapLabelType1.value);
  return map.value;
};

function zoomMap(delta) {
  if (!map.value) return;
  if (delta > 0) {
    map.value.zoomIn(1);
  } else {
    map.value.zoomOut(1);
  }
}

function resetMapView() {
  if (!map.value) return;
  map.value.setView(defaultMapView.center, defaultMapView.zoom);
}

function createMarkerIcon(type) {
  const meta = markerTypeMeta[type] || markerTypeMeta.field;
  return L.divIcon({
    className: "geo-point-marker",
    html: `<span style="--marker-color:${meta.color}">${meta.label}</span>`,
    iconSize: [58, 58],
    iconAnchor: [29, 29],
  });
}

function createDashedPolyline(coordinates, style) {
  const latLngs = coordinates.map(([lng, lat]) => [lat, lng]);
  return L.polyline(latLngs, {
    ...style,
    dashArray: [5, 5],
    lineCap: "round",
    lineJoin: "round",
  });
}

const loadBoundary = () => {
  L.geoJSON(boundaryData, {
    onEachFeature(feature, layer) {
      const style = {
        color: "#D1E211",
        fillColor: "#226FC1",
        fillOpacity: 0,
        dashArray: [1, 1],
        weight: 1,
      };

      if (feature.geometry.type === "Polygon" || feature.geometry.type === "MultiPolygon") {
        layer.setStyle(style);
        const rings =
          feature.geometry.type === "Polygon"
            ? [feature.geometry.coordinates[0]]
            : feature.geometry.coordinates.map((polygon) => polygon[0]);
        rings.forEach((ring) => map.value.addLayer(createDashedPolyline(ring, style)));
      } else if (feature.geometry.type === "LineString" || feature.geometry.type === "MultiLineString") {
        const coordinates =
          feature.geometry.type === "LineString"
            ? feature.geometry.coordinates
            : feature.geometry.coordinates[0];
        map.value.addLayer(createDashedPolyline(coordinates, style));
      }

      map.value.addLayer(layer);
    },
  }).addTo(map.value);
};

function loadGeoMarkers() {
  geoMarkerAreas.forEach((area) => {
    L.polygon(area.coordinates, {
      pane: "geoThematicPane",
      color: area.color,
      weight: 2.8,
      opacity: 0.92,
      fillColor: area.color,
      fillOpacity: 0.055,
      dashArray: "7 7",
      lineJoin: "round",
    })
      .bindTooltip(area.name, {
        permanent: false,
        sticky: true,
        direction: "top",
        className: "geo-map-tooltip",
      })
      .addTo(map.value);
  });

  geoRiverLines.forEach((line) => {
    L.polyline(line.coordinates, {
      pane: "geoThematicPane",
      color: line.color,
      weight: 5,
      opacity: 0.82,
      dashArray: "14 10",
      lineCap: "round",
      lineJoin: "round",
    })
      .bindTooltip(line.name, {
        permanent: false,
        sticky: true,
        direction: "top",
        className: "geo-map-tooltip",
      })
      .addTo(map.value);
  });

  geoMarkerPoints.forEach((point) => {
    L.marker(point.coord, {
      pane: "geoMarkerPane",
      icon: createMarkerIcon(point.type),
      title: point.name,
    })
      .bindTooltip(`<b>${point.name}</b><br>${point.value}`, {
        permanent: false,
        sticky: true,
        direction: "top",
        className: "geo-map-tooltip",
      })
      .addTo(map.value);
  });
}

function addChart(el, option) {
  if (!el) return;
  const chart = echarts.init(el);
  chart.setOption(option);
  chartInstances.push(chart);
  setTimeout(() => chart.resize(), 80);
}

function initCharts() {
  const axisColor = "rgba(190, 255, 245, 0.72)";
  const gridColor = "rgba(79, 255, 225, 0.18)";

  addChart(landBarRef.value, {
    grid: { left: 80, right: 32, top: 42, bottom: 50 },
    xAxis: {
      type: "category",
      data: ["2020", "2021", "2022", "2023", "2024"],
      axisLabel: { color: axisColor, fontSize: 22 },
      axisLine: { lineStyle: { color: gridColor } },
      axisTick: { show: false },
    },
    yAxis: {
      type: "value",
      min: 150,
      max: 165,
      axisLabel: { color: axisColor, fontSize: 22 },
      splitLine: { lineStyle: { color: gridColor, type: "dashed" } },
    },
    series: [
      {
        type: "bar",
        barWidth: 28,
        data: [158.4, 159.2, 160.3, 161.54, 162.8],
        label: { show: true, position: "top", color: "#eafffb", fontSize: 22 },
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
            { offset: 0, color: "#0a7c6f" },
            { offset: 0.55, color: "#21dfc1" },
            { offset: 1, color: "#b8fff1" },
          ]),
        },
      },
    ],
  });

  addChart(buildPieRef.value, {
    legend: { show: false },
    series: [
      {
        type: "pie",
        radius: ["58%", "78%"],
        center: ["50%", "50%"],
        startAngle: 90,
        avoidLabelOverlap: false,
        label: { show: false },
        data: [
          { value: 18717.81, name: "农村居民点" },
          { value: 2123.85, name: "集镇住宅" },
          { value: 338.31, name: "工矿配套" },
        ],
        itemStyle: { borderColor: "rgba(5, 32, 30, 0.98)", borderWidth: 4 },
        color: ["#18ddca", "#6dffcf", "#b9fff0"],
      },
    ],
  });

  addChart(weatherLineRef.value, {
    tooltip: { trigger: "axis", textStyle: { fontSize: 24 } },
    grid: { left: 32, right: 34, top: 36, bottom: 58 },
    xAxis: {
      type: "category",
      data: getRecentDateLabels(),
      axisLabel: { color: axisColor, fontSize: 22 },
      axisLine: { lineStyle: { color: gridColor } },
      axisTick: { show: false },
    },
    yAxis: {
      type: "value",
      min: 0,
      max: 40,
      axisLabel: { color: axisColor, fontSize: 22 },
      splitLine: { lineStyle: { color: gridColor, type: "dashed" } },
    },
    series: [
      {
        type: "line",
        name: "日均气温",
        smooth: true,
        symbol: "circle",
        symbolSize: 10,
        data: [23.4, 24.1, 25.0, 24.8, 25.6, 31.6, 21.2],
        lineStyle: { width: 5, color: "#43ff92" },
        itemStyle: { color: "#75ffb5" },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(67,255,146,0.55)" },
            { offset: 1, color: "rgba(67,255,146,0.02)" },
          ]),
        },
      },
    ],
  });

  sparkRefs.value.forEach((el, index) => {
    addChart(el, {
      grid: { left: 0, right: 0, top: 8, bottom: 0 },
      xAxis: { type: "category", show: false, data: [1, 2, 3, 4, 5, 6, 7] },
      yAxis: { type: "value", show: false },
      series: [
        {
          type: "line",
          smooth: true,
          symbol: "none",
          data: [
            12 + index,
            14 + index,
            13 + index,
            17 + index,
            26 + index,
            20 + index,
            22 + index,
          ],
          lineStyle: { color: "#21f5d1", width: 4 },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "rgba(33,245,209,0.45)" },
              { offset: 1, color: "rgba(33,245,209,0)" },
            ]),
          },
        },
      ],
    });
  });
}

function resizeCharts() {
  chartInstances.forEach((chart) => chart.resize());
}

const removeMap = () => {
  if (mapObj.value) {
    mapObj.value.remove();
    mapObj.value = null;
    map.value = null;
  }
};

onMounted(() => {
  map.value = L.map(mapRef.value, {
    center: defaultMapView.center,
    zoom: defaultMapView.zoom,
    minZoom: 3,
    maxZoom: 19,
    noWrap: true,
    zoomControl: false,
    zoomSnap: 0.5,
    zoomDelta: 0.5,
    wheelPxPerZoomLevel: 80,
    scrollWheelZoom: true,
    doubleClickZoom: true,
    touchZoom: true,
    dragging: true,
    attributionControl: false,
  });

  mapObj.value = initMap();
  loadBoundary();
  loadGeoMarkers();
  nextTick(initCharts);
  window.addEventListener("resize", resizeCharts);
});

onUnmounted(() => {
  window.removeEventListener("resize", resizeCharts);
  chartInstances.forEach((chart) => chart.dispose());
  chartInstances.length = 0;
  removeMap();
});
</script>

<style lang="less" scoped>
.mapBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.mainBox {
  width: 100%;
  height: 100%;
  background: url(../../src/assets/img/map_bg.png);
  background-size: cover;
  position: relative;
  z-index: 2;
  pointer-events: none;
  overflow: hidden;
  color: #effffb;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}

.mainBox :deep(.titleBg) {
  pointer-events: auto;
}

.mapBox :deep(.geo-marker-satellite-tile) {
  filter: brightness(0.78) contrast(1.14) saturate(1.16) hue-rotate(6deg);
}

.mapBox :deep(.leaflet-overlay-pane svg path) {
  filter: drop-shadow(0 0 4px rgba(72, 255, 232, 0.42));
}

.geo-marker-legend {
  position: absolute;
  left: 50%;
  bottom: 86px;
  z-index: 8;
  transform: translateX(-50%);
  display: grid;
  grid-template-columns: repeat(4, auto);
  gap: 22px;
  padding: 16px 26px;
  box-sizing: border-box;
  pointer-events: auto;
  background:
    linear-gradient(180deg, rgba(4, 70, 69, 0.72), rgba(2, 32, 35, 0.86)),
    repeating-linear-gradient(90deg, rgba(61, 255, 234, 0.08) 0, rgba(61, 255, 234, 0.08) 1px, transparent 1px, transparent 24px);
  border: 1px solid rgba(76, 255, 235, 0.58);
  box-shadow: inset 0 0 22px rgba(48, 255, 226, 0.18), 0 0 20px rgba(38, 255, 231, 0.18);
  clip-path: polygon(16px 0, calc(100% - 16px) 0, 100% 16px, 100% calc(100% - 16px), calc(100% - 16px) 100%, 16px 100%, 0 calc(100% - 16px), 0 16px);
}

.geo-marker-legend div {
  display: flex;
  align-items: center;
  color: #eafffb;
  font-size: 26px;
  line-height: 34px;
  font-weight: 800;
  white-space: nowrap;
}

.geo-marker-legend i {
  width: 34px;
  height: 16px;
  margin-right: 10px;
  border: 1px solid rgba(255, 255, 255, 0.58);
  box-shadow: 0 0 12px currentColor;
}

.map-zoom-tools {
  position: absolute;
  left: 56%;
  top: 230px;
  z-index: 9;
  transform: translateX(490px);
  display: grid;
  grid-template-columns: 80px 80px 80px;
  gap: 20px;
  pointer-events: auto;
}

.map-zoom-tools button {
  width: 80px;
  height: 70px;
  border: 1px solid rgba(96, 255, 238, 0.78);
  color: #eafffb;
  font-size: 30px;
  line-height: 1;
  font-weight: 900;
  cursor: pointer;
  background:
    linear-gradient(180deg, rgba(8, 92, 88, 0.58), rgba(3, 42, 43, 0.9)),
    repeating-linear-gradient(90deg, rgba(61, 255, 234, 0.08) 0, rgba(61, 255, 234, 0.08) 1px, transparent 1px, transparent 18px);
  box-shadow: inset 0 0 18px rgba(52, 255, 231, 0.2), 0 0 16px rgba(52, 255, 231, 0.18);
  clip-path: polygon(10px 0, calc(100% - 10px) 0, 100% 10px, 100% calc(100% - 10px), calc(100% - 10px) 100%, 10px 100%, 0 calc(100% - 10px), 0 10px);
}

.map-zoom-tools button:hover {
  color: #ffffff;
  border-color: rgba(175, 255, 247, 0.96);
  background:
    linear-gradient(180deg, rgba(17, 126, 116, 0.92), rgba(4, 58, 58, 0.92)),
    repeating-linear-gradient(90deg, rgba(61, 255, 234, 0.1) 0, rgba(61, 255, 234, 0.1) 1px, transparent 1px, transparent 18px);
}

.mapBox :deep(.geo-point-marker) {
  background: transparent;
  border: none;
}

.mapBox :deep(.geo-point-marker span) {
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 25px;
  line-height: 1;
  font-weight: 900;
  border: 2px solid var(--marker-color);
  border-radius: 50%;
  background: radial-gradient(circle, color-mix(in srgb, var(--marker-color) 44%, transparent), rgba(2, 36, 39, 0.76) 62%);
  box-shadow: 0 0 0 6px color-mix(in srgb, var(--marker-color) 16%, transparent), 0 0 20px var(--marker-color), inset 0 0 16px color-mix(in srgb, var(--marker-color) 32%, transparent);
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

.mapBox :deep(.geo-map-tooltip) {
  padding: 8px 14px;
  color: #ffffff;
  font-size: 24px;
  font-weight: 900;
  line-height: 32px;
  letter-spacing: 0;
  background: rgba(3, 35, 38, 0.74);
  border: 1px solid rgba(129, 255, 240, 0.72);
  box-shadow: 0 0 18px rgba(63, 255, 234, 0.34);
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.42);
}

.mapBox :deep(.geo-map-tooltip::before) {
  display: none;
}

.content {
  position: absolute;
  top: 190px;
  left: 70px;
  right: 70px;
  height: calc(100% - 230px);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  pointer-events: auto;
}

.left-panel {
  width: 1832px;
  height: 100%;
  display: grid;
  grid-template-rows: 504px 1fr;
  gap: 50px;
}

.right-panel {
  width: 1897px;
  height: 100%;
}

.glass-card,
.empty-frame {
  position: relative;
  box-sizing: border-box;
  background:
    linear-gradient(180deg, rgba(7, 88, 78, 0.6), rgba(3, 45, 41, 0.86)),
    repeating-linear-gradient(90deg, rgba(42, 255, 230, 0.045) 0, rgba(42, 255, 230, 0.045) 1px, transparent 1px, transparent 32px);
  border: 2px solid rgba(44, 255, 229, 0.56);
  box-shadow: inset 0 0 45px rgba(28, 255, 224, 0.16), 0 0 20px rgba(28, 255, 224, 0.13);
}

.glass-card::before {
  content: "";
  position: absolute;
  left: 18px;
  top: 0;
  right: 18px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #5effec, transparent);
}

.section-title,
.panel-title,
.card-title {
  height: 74px;
  display: flex;
  align-items: center;
  padding-left: 22px;
  box-sizing: border-box;
  color: #ffffff;
  font-size: 32px;
  font-weight: 900;
  line-height: 54px;
  background: linear-gradient(90deg, rgba(20, 164, 141, 0.55), rgba(7, 96, 86, 0.18));
  text-shadow: 0 0 10px rgba(120, 255, 238, 0.55);
}

.section-title::before,
.panel-title::before {
  content: "";
  width: 8px;
  height: 28px;
  margin-right: 12px;
  background: #4dffdb;
  box-shadow: 0 0 14px rgba(77, 255, 219, 0.8);
}

.chart {
  width: 100%;
  height: 100%;
  min-width: 0;
}

.top-row {
  // height: 475px;
  display: grid;
  grid-template-columns: 825px 1fr;
  gap: 24px;
}

.top-row-left {
  display: grid;
  grid-template-rows: 74px 1fr;
}

.land-content {
  height: 100%;
  min-height: 0;
  display: grid;
  grid-template-columns: 315px 1fr;
  gap: 18px;
  padding: 22px 0 0;
  box-sizing: border-box;
  overflow: hidden;
}

.land-card {
  padding: 0 24px 24px;
}

.land-left {
  min-width: 0;
  height: 100%;
  padding-right: 22px;
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  position: relative;
}

.land-left::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, transparent, rgba(106, 255, 238, 0.75), transparent);
  box-shadow: 0 0 12px rgba(106, 255, 238, 0.58);
}

.land-right {
  min-width: 0;
  height: 100%;
  display: grid;
  grid-template-rows: minmax(0, 1fr) 42px;
  overflow: hidden;
}

.land-main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 18px 0 4px;
  box-sizing: border-box;
}

.land-number {
  color: #ffffff;
  font-size: 86px;
  line-height: 98px;
  font-weight: 900;
  text-shadow: 0 0 16px rgba(255, 255, 255, 0.34);
  display: flex;
  flex-direction: column;
}

.land-number span {
  margin-left: 14px;
  color: #ffffff;
  font-size: 34px;
}

.land-label {
  color: #dffff9;
  font-size: 30px;
  font-weight: 800;
}

.increase-grid {
  height: 120px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.increase-grid b {
  display: block;
  color: #dbfff9;
  font-size: 26px;
  line-height: 34px;
}

.increase-grid strong {
  display: block;
  margin-top: 8px;
  color: #95fff0;
  font-size: 32px;
  line-height: 38px;
  white-space: nowrap;
}

.chart-card {
  padding: 18px 12px 42px;
}

.full-chart {
  height: 100%;
  min-height: 300px;
}

.chart-caption {
  color: #d7fff8;
  font-size: 26px;
  line-height: 42px;
  text-align: center;
  white-space: nowrap;
}

.water-card {
  padding-bottom: 22px;
}

.water-kpis {
  height: 176px;
  margin: 22px 24px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border: 1px solid rgba(62, 255, 230, 0.38);
}

.water-kpis div {
  padding: 20px 10px;
  text-align: center;
  border-right: 1px solid rgba(91, 255, 237, 0.24);
}

.water-kpis div:last-child {
  border-right: none;
}

.water-kpis span,
.water-kpis p {
  margin: 0;
  color: #defdf7;
  font-size: 26px;
  line-height: 34px;
}

.water-kpis b {
  color: #31fff0;
  font-size: 58px;
  line-height: 66px;
}

.water-kpis em {
  color: #dffff9;
  font-style: normal;
  font-size: 26px;
}

.water-bottom {
  margin: 0 24px;
  display: grid;
  grid-template-columns: 1fr 310px;
  gap: 18px;
}

.water-table {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  padding: 16px;
  border: 1px solid rgba(62, 255, 230, 0.34);
  line-height: 40px;
}

.water-table p,
.water-summary p {
  margin: 0;
}

.water-table span,
.water-summary span {
  display: block;
  color: #dffff9;
  font-size: 26px;
}

.water-table b {
  color: #ffffff;
  font-size: 26px;
}

.water-summary {
  padding: 18px;
  border: 1px solid rgba(62, 255, 230, 0.34);
}

.water-summary p {
  margin-bottom: 20px;
}

.water-summary b {
  color: #2dfff0;
  font-size: 42px;
}

.build-section {
  margin-top: 70px;
}

.build-section h2 {
  margin: 0;
  color: #ffffff;
  font-size: 54px;
  line-height: 68px;
  font-weight: 900;
}

.subtitle {
  margin: 0 0 38px;
  color: #f2fffb;
  font-size: 34px;
  font-weight: 800;
}

.build-overview {
  height: 260px;
  padding: 22px 44px;
  display: grid;
  grid-template-columns: 1fr 220px 300px 390px;
  gap: 30px;
  align-items: center;
  clip-path: polygon(30px 0, 100% 0, 100% calc(100% - 30px), calc(100% - 30px) 100%, 0 100%, 0 30px);
}

.overview-title {
  margin-bottom: 36px;
  color: #ffffff;
  font-size: 30px;
  font-weight: 900;
}

.scale-line {
  height: 24px;
  background: rgba(92, 255, 231, 0.15);
  border-top: 1px dashed rgba(180, 255, 244, 0.22);
  border-bottom: 1px dashed rgba(180, 255, 244, 0.22);
}

.scale-line span {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, #16e9d1, #9dfff0);
  box-shadow: 0 0 20px rgba(33, 255, 227, 0.6);
}

.build-values {
  margin-top: 28px;
  display: flex;
  justify-content: space-around;
}

.build-values b {
  color: #73ffec;
  font-size: 48px;
  line-height: 56px;
}

.build-values span {
  margin-left: 8px;
  color: #ffffff;
  font-size: 26px;
}

.total-list span {
  color: #ffffff;
  font-size: 28px;
  font-weight: 900;
}

.total-list p {
  margin: 15px 0 0;
  color: #dffff9;
  font-size: 31px;
  font-weight: 900;
}

.pie-chart {
  height: 220px;
}

.pie-note p {
  margin: 8px 0;
  color: #ffffff;
  font-size: 26px;
  line-height: 32px;
}

.pie-note b {
  color: #dffff9;
}

.build-cards {
  margin-top: 42px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
}

.small-card {
  height: 210px;
  padding: 24px 34px;
  clip-path: polygon(28px 0, 100% 0, 100% calc(100% - 28px), calc(100% - 28px) 100%, 0 100%, 0 28px);
}

.small-card h3 {
  margin: 0 0 14px;
  color: #ffffff;
  font-size: 30px;
  text-align: center;
}

.small-card b {
  display: block;
  color: #75ffec;
  font-size: 46px;
  text-align: center;
}

.small-card b span {
  margin-left: 8px;
  color: #ffffff;
  font-size: 26px;
}

.small-card p {
  margin: 8px 0 0;
  color: #f1fffb;
  font-size: 26px;
  line-height: 34px;
  font-weight: 700;
}

.source-line {
  margin-top: 52px;
  padding: 18px 48px;
  color: #eafffb;
  font-size: 26px;
  line-height: 38px;
  text-align: center;
  border: 1px dashed rgba(78, 255, 232, 0.46);
}

.right-layout {
  height: 100%;
  display: grid;
  grid-template-columns: 530px 1fr;
  gap: 28px;
}

.zone-column {
  height: 100%;
  padding: 28px;
  box-sizing: border-box;
  background: rgba(1, 49, 45, 0.76);
  border-left: 2px solid rgba(28, 255, 224, 0.42);
  border-right: 2px solid rgba(28, 255, 224, 0.18);
  display: grid;
  grid-template-rows: 58px 1fr 88px;
  gap: 28px;
}

.zone-grid {
  margin-top: 22px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.zone-item {
  height: 146px;
  padding: 22px 14px;
  box-sizing: border-box;
  background: rgba(5, 87, 78, 0.62);
}

.zone-item span {
  display: block;
  color: #e8fffb;
  font-size: 26px;
  font-weight: 800;
}

.zone-item b {
  display: block;
  margin-top: 12px;
  color: #31fff0;
  font-size: 36px;
  line-height: 48px;
}

.zone-item b.warm {
  color: #ffa96f;
}

.title-gap {
  margin-top: 38px;
}

.weather-chart {
  height: 400px;
  margin-top: 18px;
}

.monitor-column {
  min-width: 0;
  display: grid;
  grid-template-rows:108px 510px 1fr;
  gap: 50px;
}

.main-heading {
  height: 108px;
  text-align: center;
}

.main-heading h2 {
  margin: 0;
  color: #ffffff;
  font-size: 36px;
  font-weight: 900;
  margin-bottom: 12px;
}

.main-heading p {
  margin: 0;
  color: #aafdf1;
  font-size: 26px;
}

.monitor-top {

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
}

.satellite-card,
.station-card {
  padding: 0 22px 22px;
  clip-path: polygon(34px 0, calc(100% - 34px) 0, 100% 34px, 100% 100%, 0 100%, 0 34px);
}

.card-title {
  width: 70%;
  margin: 0 auto;
  justify-content: center;
  padding-left: 0;
  font-size: 28px;
}

.sat-body {
  padding-top: 26px;
  display: grid;
  grid-template-rows: 154px 1fr;
  gap: 16px;
}

.sat-map {
  width: 100%;
  height: 154px;
  img {
    width: 100%;
    height: 100%;
  }
}

.field-grid,
.route-lines {
  border: 1px solid rgba(83, 255, 234, 0.36);
  background:
    linear-gradient(135deg, rgba(49, 125, 89, 0.65) 0 24%, transparent 24% 30%, rgba(19, 104, 86, 0.62) 30% 54%, transparent 54% 60%, rgba(93, 127, 87, 0.72) 60%),
    repeating-linear-gradient(45deg, rgba(54, 143, 245, 0.55) 0 4px, transparent 4px 20px);
}

.route-lines {
  background:
    radial-gradient(circle at 35% 30%, rgba(80, 255, 229, 0.8) 0 2px, transparent 3px),
    radial-gradient(circle at 74% 68%, rgba(80, 255, 229, 0.7) 0 2px, transparent 3px),
    repeating-radial-gradient(ellipse at center, transparent 0 20px, rgba(56, 255, 226, 0.45) 21px 23px, transparent 24px 44px);
}

.sat-steps {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.sat-steps span {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dffff9;
  font-size: 26px;
  border: 1px solid rgba(67, 255, 231, 0.5);
  background: rgba(15, 127, 111, 0.5);
}

.sat-info {
  grid-column: 1 / 3;
  padding: 18px 22px;
  background: rgba(5, 92, 82, 0.62);
  border: 1px solid rgba(55, 255, 229, 0.36);
  border-radius: 8px;
}

.sat-info p {
  margin: 0 0 16px;
  display: grid;
  grid-template-columns: 190px 130px 1fr;
  gap: 14px;
  color: #f1fffb;
  font-size: 26px;
}

.sat-info p:last-child {
  margin-bottom: 0;
}

.sat-info b,
.sat-info span,
.sat-info em {
  font-size: 26px;
  font-style: normal;
}

.station-list {
  padding: 20px 0 0;
}

.station-item {
  min-height: 116px;
  margin-bottom: 18px;
  padding: 20px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 60px 1fr 210px;
  gap: 18px;
  align-items: center;
  background: rgba(5, 92, 82, 0.56);
  border: 1px solid rgba(55, 255, 229, 0.36);
  border-radius: 8px;
}

.station-item i,
.business-row i {
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6ffff0;
  font-size: 26px;
  font-style: normal;
  border: 2px solid rgba(77, 255, 230, 0.58);
  border-radius: 50%;
  box-shadow: inset 0 0 16px rgba(77, 255, 230, 0.18);
}

.station-item h3,
.business-row h3 {
  margin: 0;
  color: #ffffff;
  font-size: 26px;
  text-align: left;
}

.station-item p,
.business-row p {
  margin: 8px 0 0;
  color: #dffff9;
  font-size: 26px;
  line-height: 34px;
  text-align: left;
}

.station-item b {
  color: #eafffb;
  font-size: 26px;
  line-height: 34px;
}

.business-section {
  margin-top: 34px;
  // height: calc(100% - 632px);
  // min-height: 620px;
  padding-top: 18px;
  background: linear-gradient(180deg, rgba(4, 55, 50, 0.74), rgba(2, 34, 32, 0.72));
  display: grid;
  grid-template-rows: 58px 1fr;
  gap: 28px;
}

.small-heading {
  height: 88px;
}

.business-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
  padding: 0 28px;
}

.business-card {
  // height: 450px;
  padding: 0 24px 24px;
  clip-path: polygon(28px 0, calc(100% - 28px) 0, 100% 28px, 100% 100%, 0 100%, 0 28px);
}

.field-card{
  display: grid;
  grid-template-rows: 74px 1fr 1fr 1fr;
  gap: 28px;
}
.business-row {
  height: 112px;
  display: grid;
  grid-template-columns: 62px 1fr 170px;
  gap: 16px;
  align-items: center;
  border-bottom: 1px solid rgba(58, 255, 230, 0.24);
}

.business-row:last-child {
  border-bottom: none;
}

.spark-chart {
  width: 170px;
  height: 70px;
}

.source-note {
  margin-top: 20px;
  color: #dffff9;
  font-size: 26px;
  text-align: center;
}
</style>
